import React, { useEffect, useState } from 'react'
import { DetailsRow } from '../DetailsRow'
import { DetailsColumn } from '../DetailsColumn'
import { FieldsRow } from '../FieldsRow'
import { fetchFerryService } from 'services'
import { useErrorHandling } from 'context/errorHandling'
import { fetchContractor } from 'services/ContractorService'
import { ReadOnlyTextField } from 'components/Shared/ReadOnlyTextField'
import Sections from 'components/Order/sections'

export function FerryPassageDetails ({ ferryPassage, diffValues }) {
  const [contractor, setContractor] = useState()
  const [ferryService, setFerryService] = useState()

  const [previousContractor, setPreviousContractor] = useState()
  const [previousFerryService, setPreviousFerryService] = useState()

  const { handleError } = useErrorHandling()

  useEffect(() => {
    if (diffValues) {
      if (diffValues.ferryServiceId !== ferryPassage.ferryServiceId) {
        fetchFerryService(diffValues.ferryServiceId)
          .then(setPreviousFerryService)
          .catch(handleError)
      }
      if (diffValues.contractorId !== ferryPassage.contractorId) {
        fetchFerryService(diffValues.contractorId)
          .then(setPreviousContractor)
          .catch(handleError)
      }
    }
  }, [diffValues, ferryPassage, handleError])

  useEffect(() => {
    fetchFerryService(ferryPassage.ferryServiceId)
      .then(setFerryService)
      .catch(handleError)
  }, [ferryPassage.ferryServiceId, handleError])

  useEffect(() => {
    if (ferryService) {
      fetchContractor(ferryService.contractorId)
        .then(setContractor)
        .catch(handleError)
    }
  }, [ferryService, handleError])

  return (
    <DetailsRow section={Sections.FerryPassage}>
      <DetailsColumn>
        <ReadOnlyTextField label="order.details.ferryPassage.fields.contractor"
                           value={contractor?.shortName}
                           previousValue={previousContractor && { value: previousContractor.shortName }}
        />
        <ReadOnlyTextField label="order.details.ferryPassage.fields.ferryService"
                           value={ferryService ? formatFerryServiceTitle(ferryService) : ''}
                           previousValue={previousFerryService && { value: formatFerryServiceTitle(previousFerryService) }}

        />
        <ReadOnlyTextField label="order.details.ferryPassage.fields.harbourCoordinates"
                           value={ferryPassage.harbourLocation.text}
                           previousValue={diffValues && { value: diffValues.harbourLocation.text }}

        />
      </DetailsColumn>
      <DetailsColumn>
        <FieldsRow>
          <ReadOnlyTextField label='order.details.ferryPassage.fields.price.amount'
                             value={ferryPassage.price.amount}
                             previousValue={diffValues && { value: diffValues.price.amount }}
          />
          <ReadOnlyTextField label='order.details.ferryPassage.fields.price.currency'
                             value={ferryPassage.price.currencyCode}
                             previousValue={diffValues && { value: diffValues.price.currencyCode }}
          />
        </FieldsRow>
        <FieldsRow>
          <ReadOnlyTextField label='order.details.ferryPassage.fields.bunkerAdjustmentFactor.amount'
                             value={ferryPassage.bunkerAdjustmentFactor.amount}
                             previousValue={diffValues && { value: diffValues.bunkerAdjustmentFactor.amount }}
          />
          <ReadOnlyTextField label='order.details.ferryPassage.fields.bunkerAdjustmentFactor.currency'
                             value={ferryPassage.bunkerAdjustmentFactor.currencyCode}
                             previousValue={diffValues && { value: diffValues.bunkerAdjustmentFactor.currencyCode }}
          />
        </FieldsRow>
        <ReadOnlyTextField
          label={'form.order.transaction.paymentDays'}
          value={ferryPassage.paymentDays}
        />
        <ReadOnlyTextField label='order.details.ferryPassage.fields.additionalInfo'
                           value={ferryPassage.additionalInfo}
                           previousValue={diffValues && { value: diffValues.additionalInfo }}
        />
      </DetailsColumn>
    </DetailsRow>
  )
}

const formatFerryServiceTitle = fs => `${fs.startLocation.text} - ${fs.endLocation.text}`
